import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { CreateOrPatchTax, Tax } from '@thro-types/billing';

import { AxiosRequestConfig } from 'axios';

import { createTaxes, getTaxes, UpdateInterface, updateTaxes } from 'api/billingService';

export const useGetSalesTaxesListQuery = (config?: AxiosRequestConfig) => {
  const queryKey = ['salesTaxes', config ? JSON.stringify(config.params) : ''];
  return useQuery({
    queryKey,
    queryFn: () => {
      return getTaxes(config);
    },
    initialData: { data: [], count: 0, dataCount: 0 }
  });
};

export const useTaxesMutation = (config?: AxiosRequestConfig) => {
  const queryClient = useQueryClient();

  const queryKey = ['salesTaxes'];
  const creation = useMutation<Tax, Error, CreateOrPatchTax>({
    mutationFn: async args => {
      return await createTaxes(args, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });

  const update = useMutation<Tax, Error, UpdateInterface<CreateOrPatchTax>>({
    mutationFn: async args => {
      return await updateTaxes(args, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });

  return { creation, update } as const;
};
